(function () {
    'use strict';

    const MOBILE_BP = '(max-width: 1024px)';
    const SECTION_SELECTOR = '[data-sk-sales-reps]';
    const LOG_PREFIX = '[sk-sales-reps]';

    function debounce(fn, delay) {
        let t;
        return function () {
            clearTimeout(t);
            t = setTimeout(fn, delay);
        };
    }

    function parseInitialCount(value, root) {
        if (value === undefined || value === '') return 4;
        const parsed = parseInt(value, 10);
        if (!Number.isFinite(parsed) || parsed < 1) {
            console.warn(LOG_PREFIX, 'data-initial-count is invalid, falling back to 4', { value: value, section: root });
            return 4;
        }
        return parsed;
    }

    function initSection(root) {
        if (root.__skSalesRepsInit) return;
        root.__skSalesRepsInit = true;

        const tabs = Array.from(root.querySelectorAll('[data-sr-tab]'));
        const cards = Array.from(root.querySelectorAll('[data-tag]'));
        const revealBtn = root.querySelector('[data-sk-sr-reveal]');
        const revealCountEl = root.querySelector('[data-sr-count]');
        const mobileMQ = window.matchMedia(MOBILE_BP);

        if (cards.length === 0) {
            console.warn(LOG_PREFIX, 'initialized with no [data-tag] cards', root);
            return;
        }

        const initialCount = parseInitialCount(root.dataset.initialCount, root);
        const revealEnabled = root.dataset.mobileReveal !== 'false';

        if (revealEnabled && !revealBtn) {
            console.warn(LOG_PREFIX, 'mobile reveal enabled but [data-sk-sr-reveal] button missing', root);
        }

        let activeTag = '__all__';
        const activeTab = tabs.find(function (t) {
            return t.getAttribute('aria-selected') === 'true';
        });
        if (activeTab) {
            activeTag = activeTab.dataset.srTab;
        } else if (tabs.length > 0) {
            console.warn(LOG_PREFIX, 'no tab marked aria-selected, defaulting to first tab', root);
            activeTag = tabs[0].dataset.srTab;
            tabs[0].classList.add('is-active');
            tabs[0].setAttribute('aria-selected', 'true');
        }

        function matchingCards() {
            if (activeTag === '__all__') return cards.slice();
            return cards.filter(function (c) {
                return c.dataset.tag === activeTag;
            });
        }

        function applyFilter() {
            const matching = matchingCards();
            const matchSet = new Set(matching);
            const isMobile = mobileMQ.matches;

            cards.forEach(function (card) {
                if (!matchSet.has(card)) {
                    card.setAttribute('data-sr-hidden', 'filter');
                    return;
                }
                card.removeAttribute('data-sr-hidden');
            });

            if (isMobile && revealEnabled && !root.dataset.revealExpanded) {
                matching.slice(initialCount).forEach(function (card) {
                    card.setAttribute('data-sr-hidden', 'reveal');
                });
            }

            updateRevealButton(matching.length);
        }

        function updateRevealButton(totalMatching) {
            if (!revealBtn) return;
            const isMobile = mobileMQ.matches;
            const expanded = root.dataset.revealExpanded === 'true';
            const hiddenCount = Math.max(0, totalMatching - initialCount);

            if (!revealEnabled || !isMobile || expanded || hiddenCount <= 0) {
                revealBtn.setAttribute('hidden', '');
                return;
            }

            revealBtn.removeAttribute('hidden');
            if (revealCountEl) revealCountEl.textContent = String(hiddenCount);
        }

        function activateTab(nextTab) {
            if (!nextTab) return;
            const nextTag = nextTab.dataset.srTab;
            if (nextTag === activeTag) return;

            tabs.forEach(function (t) {
                const isActive = t === nextTab;
                t.classList.toggle('is-active', isActive);
                t.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
            activeTag = nextTag;
            delete root.dataset.revealExpanded;
            applyFilter();
        }

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                activateTab(tab);
            });
            tab.addEventListener('keydown', function (e) {
                if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
                e.preventDefault();
                const idx = tabs.indexOf(tab);
                const dir = e.key === 'ArrowRight' ? 1 : -1;
                const next = tabs[(idx + dir + tabs.length) % tabs.length];
                if (next) {
                    activateTab(next);
                    next.focus();
                }
            });
        });

        if (revealBtn) {
            revealBtn.addEventListener('click', function () {
                root.dataset.revealExpanded = 'true';
                applyFilter();
            });
        }

        const debouncedFilter = debounce(applyFilter, 150);

        if (typeof mobileMQ.addEventListener === 'function') {
            mobileMQ.addEventListener('change', applyFilter);
        } else if (typeof mobileMQ.addListener === 'function') {
            mobileMQ.addListener(applyFilter);
        } else {
            console.warn(LOG_PREFIX, 'matchMedia change listener unsupported; viewport changes will not re-filter', root);
        }

        window.addEventListener('resize', debouncedFilter);

        root.__skSalesRepsCleanup = function () {
            window.removeEventListener('resize', debouncedFilter);
            if (typeof mobileMQ.removeEventListener === 'function') {
                mobileMQ.removeEventListener('change', applyFilter);
            } else if (typeof mobileMQ.removeListener === 'function') {
                mobileMQ.removeListener(applyFilter);
            }
            delete root.__skSalesRepsInit;
            delete root.__skSalesRepsCleanup;
        };

        applyFilter();
    }

    function initAll(scope) {
        const nodes = (scope || document).querySelectorAll(SECTION_SELECTOR);
        nodes.forEach(initSection);
    }

    function teardown(scope) {
        const nodes = (scope || document).querySelectorAll(SECTION_SELECTOR);
        nodes.forEach(function (node) {
            if (typeof node.__skSalesRepsCleanup === 'function') node.__skSalesRepsCleanup();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initAll();
        });
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
        initAll(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
        teardown(e.target);
    });

    window.SKSalesReps = { init: initAll, teardown: teardown };
})();
